var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.568131 10.7481C0.707271 10.5095 1.01343 10.429 1.25196 10.5681L7.00002 13.9211L12.7481 10.5681C12.9866 10.429 13.2928 10.5095 13.4319 10.7481C13.571 10.9866 13.4905 11.2927 13.252 11.4319L7.25196 14.9319C7.09627 15.0227 6.90377 15.0227 6.74809 14.9319L0.748085 11.4319C0.509559 11.2927 0.428991 10.9866 0.568131 10.7481Z",
    fill: "#666666"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.568131 7.74806C0.707271 7.50954 1.01343 7.42897 1.25196 7.56811L7.00002 10.9211L12.7481 7.56811C12.9866 7.42897 13.2928 7.50954 13.4319 7.74806C13.571 7.98659 13.4905 8.29275 13.252 8.43189L7.25196 11.9319C7.09627 12.0227 6.90377 12.0227 6.74809 11.9319L0.748085 8.43189C0.509559 8.29275 0.428991 7.98659 0.568131 7.74806Z",
    fill: "#666666"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74808 1.06811C6.90377 0.977296 7.09627 0.977296 7.25196 1.06811L13.252 4.56811C13.4056 4.65772 13.5 4.82217 13.5 5C13.5 5.17783 13.4056 5.34228 13.252 5.43189L7.25196 8.93189C7.09627 9.0227 6.90377 9.0227 6.74808 8.93189L0.748085 5.43189C0.594476 5.34228 0.50002 5.17783 0.50002 5C0.50002 4.82217 0.594476 4.65772 0.748085 4.56811L6.74808 1.06811ZM1.99234 5L7.00002 7.92115L12.0077 5L7.00002 2.07885L1.99234 5Z",
    fill: "#666666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.568131 10.7481C0.707271 10.5095 1.01343 10.429 1.25196 10.5681L7.00002 13.9211L12.7481 10.5681C12.9866 10.429 13.2928 10.5095 13.4319 10.7481C13.571 10.9866 13.4905 11.2927 13.252 11.4319L7.25196 14.9319C7.09627 15.0227 6.90377 15.0227 6.74809 14.9319L0.748085 11.4319C0.509559 11.2927 0.428991 10.9866 0.568131 10.7481Z",
    stroke: "#666666",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.568131 7.74806C0.707271 7.50954 1.01343 7.42897 1.25196 7.56811L7.00002 10.9211L12.7481 7.56811C12.9866 7.42897 13.2928 7.50954 13.4319 7.74806C13.571 7.98659 13.4905 8.29275 13.252 8.43189L7.25196 11.9319C7.09627 12.0227 6.90377 12.0227 6.74809 11.9319L0.748085 8.43189C0.509559 8.29275 0.428991 7.98659 0.568131 7.74806Z",
    stroke: "#666666",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.74808 1.06811C6.90377 0.977296 7.09627 0.977296 7.25196 1.06811L13.252 4.56811C13.4056 4.65772 13.5 4.82217 13.5 5C13.5 5.17783 13.4056 5.34228 13.252 5.43189L7.25196 8.93189C7.09627 9.0227 6.90377 9.0227 6.74808 8.93189L0.748085 5.43189C0.594476 5.34228 0.50002 5.17783 0.50002 5C0.50002 4.82217 0.594476 4.65772 0.748085 4.56811L6.74808 1.06811ZM1.99234 5L7.00002 7.92115L12.0077 5L7.00002 2.07885L1.99234 5Z",
    stroke: "#666666",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgProducts;